/**
 * Çerez bildirimi testleri için yardımcı fonksiyonlar
 * Bu dosya sadece geliştirme aşamasında kullanılmak üzere tasarlanmıştır
 */

import { isEuropeanUnion, isTurkey, shouldShowCookieConsent } from './geoUtils';
import { setSecureStorage, getSecureStorage } from './security/cookieUtils';

/**
 * Farklı ülke kodları için çerez bildirimi davranışını test eder
 * @param {string} countryCode - Test edilecek ülke kodu
 * @returns {Object} Test sonuçları
 */
export const testCookieConsentForCountry = async (countryCode) => {
  // Önce mevcut ülke kodunu yedekle
  const originalCountryCode = localStorage.getItem('user_country_code');
  const originalTimestamp = localStorage.getItem('user_country_code_timestamp');
  
  // Test için ülke kodunu ayarla
  localStorage.setItem('user_country_code', countryCode);
  localStorage.setItem('user_country_code_timestamp', Date.now());
  
  // Çerez bildirimini temizle
  localStorage.removeItem('cookieAccepted');
  setSecureStorage('cookieConsent', null);
  
  // Testleri çalıştır
  const results = {
    countryCode,
    isEU: isEuropeanUnion(countryCode),
    isTR: isTurkey(countryCode),
    shouldShow: await shouldShowCookieConsent(),
  };
  
  // Orijinal değerleri geri yükle
  if (originalCountryCode) {
    localStorage.setItem('user_country_code', originalCountryCode);
    localStorage.setItem('user_country_code_timestamp', originalTimestamp);
  } else {
    localStorage.removeItem('user_country_code');
    localStorage.removeItem('user_country_code_timestamp');
  }
  
  return results;
};

/**
 * Çerez bildirimini test etmek için konsol komutları
 */
export const runCookieConsentTests = async () => {
  console.group('Çerez Bildirimi Testleri');
  
  // Avrupa ülkesi testi (Almanya)
  console.log('Almanya için test:', await testCookieConsentForCountry('DE'));
  
  // Türkiye testi
  console.log('Türkiye için test:', await testCookieConsentForCountry('TR'));
  
  // AB dışı ülke testi (ABD)
  console.log('ABD için test:', await testCookieConsentForCountry('US'));
  
  // Geçersiz ülke kodu testi
  console.log('Geçersiz ülke kodu için test:', await testCookieConsentForCountry('XX'));
  
  console.groupEnd();
};

/**
 * Çerez kabul/red işlemlerini test eder
 */
export const testCookieActions = () => {
  console.group('Çerez İşlemleri Testleri');
  
  // Önce mevcut değerleri temizle
  localStorage.removeItem('cookieAccepted');
  setSecureStorage('cookieConsent', null);
  
  // Başlangıç durumunu kontrol et
  console.log('Başlangıç durumu:', {
    oldConsent: localStorage.getItem('cookieAccepted'),
    newConsent: getSecureStorage('cookieConsent')
  });
  
  // Kabul işlemini test et
  const acceptCookies = () => {
    setSecureStorage('cookieConsent', 'accepted');
    localStorage.setItem('cookieAccepted', 'true');
  };
  
  acceptCookies();
  console.log('Kabul sonrası:', {
    oldConsent: localStorage.getItem('cookieAccepted'),
    newConsent: getSecureStorage('cookieConsent')
  });
  
  // Temizle
  localStorage.removeItem('cookieAccepted');
  setSecureStorage('cookieConsent', null);
  
  // Red işlemini test et
  const rejectCookies = () => {
    setSecureStorage('cookieConsent', 'rejected');
    localStorage.setItem('cookieAccepted', 'false');
  };
  
  rejectCookies();
  console.log('Red sonrası:', {
    oldConsent: localStorage.getItem('cookieAccepted'),
    newConsent: getSecureStorage('cookieConsent')
  });
  
  console.groupEnd();
};

// Konsol üzerinden testleri çalıştırmak için global değişkenler
window.cookieTests = {
  runCookieConsentTests,
  testCookieActions,
  testCookieConsentForCountry
};
